import { render, staticRenderFns } from "./CenterFare.vue?vue&type=template&id=14088355&scoped=true"
import script from "./CenterFare.vue?vue&type=script&lang=js"
export * from "./CenterFare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14088355",
  null
  
)

export default component.exports